// extracted by css-extract-rspack-plugin
export default {"selectionWidth":"_9458c62f"};